<div class="container">
  <div class="row">
    <div class="col-md-12">

      <h2 class="rounded text-center bg-warning text-dark">View Group Session</h2>
      <table class="table table-active">
        <tbody>
        <p>Centre Details</p>
        <tr>
          <th> Stundent Names </th>
          <td>{{getchildrenNames(data.children)}}</td>
        </tr>

        <tr>
          <th> Centre Name </th>
          <td>{{getCentresString(data.centres)}}</td>
        </tr>
        <br>

        <p> Child Details </p>
        <tr>
          <th>Child Code </th>
          <td>{{getChildcode(data.children)}}</td>
        </tr>

        <tr *ngIf="data.parentsName">
          <th>Parents Name</th>
          <td>{{data.parentsName}}</td>
        </tr>
        <br>
        <!*---------------------------------------------PRESENT TABLE--------------------------------------------->

        <tr   class="text-center">
<td colspan="2">
  <h2 class="text-center">Attendance</h2>
          <table class="table borderless" *ngIf="this.data.children.length>0">
            <thead>
            <tr>
              <th scope="col"><strong>Child Name</strong></th>
              <th scope="col"><strong>Unit Code</strong></th>
              <th scope="col"><strong>Gender</strong></th>
              <th scope="col"><strong>Is Follow-up</strong></th>
              <!--                        <th scope="col" ><strong>Centre Name</strong> </th>-->
              <th scope="col"><strong>Attendance</strong></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let c of this.data.children;let i = index">
              <td>{{c.childName}}</td>
              <td>{{c.unitCode}}</td>
              <td>{{c.gender}}</td>
              <!--                        <td  >{{c.centreName}}</td>-->
              <td>{{c.isFollowUp}}</td>
              <td>{{c.status}}</td>
            </tr>
            </tbody>
          </table>
</td>
        </tr>



        <p>Session Details</p>

        <tr>
          <th>Subject</th>
          <td>{{data.subject}}</td>
        </tr>
        <tr>
          <th>Session Date</th>
          <td>{{getDate(data?.sessionDate)}}</td>
        </tr>

        <tr>
          <th>Start Time</th>
          <td>{{getTime(data?.startTime)}}</td>
        </tr>
        <tr>
          <th>End Time</th>
          <td>{{getTime(data?.endTime)}}</td>
        </tr>
        <tr>
          <th>Session Type</th>
          <td>{{data?.sessionType}}</td>

        </tr>
        <tr>
          <th>Session Details</th>
          <td>{{data?.sessionDetails}}</td>
        </tr>

        <tr>
          <th>Topics Covered</th>
          <td>{{data?.topicsCovered}}</td>
        </tr>
        <br>
        <tr>
          <th> Conducted By </th>
          <td>{{data?.submittedBy}}</td>
        </tr>
        <tr>

          <th> Conducted By (If by  Volunteer ) </th>

          <td>{{data?.volunteerName}}</td>

        </tr>

        <p>Remark</p>
        <tr>
          <th>Remark</th>
          <td>{{data?.remark}}</td>
        </tr>

        </tbody>

      </table>
    </div>

    <div class="col-md-12">
      <h2 class="rounded  text-center bg-warning text-dark">Documents & Uploads</h2>
      <!--            <h3>Data will be uploaded to {{mStoragePath}} in {{mDbType}} at {{mPath}} </h3>-->
      <div class="col-md-6">
        <app-file-upload [storagePath]="mStoragePath" [dbPath]="mPath" fileCount="multi"></app-file-upload>
      </div>
      <div class="cdk-virtual-scroll-data-source-example">
        <cdk-virtual-scroll-viewport orientation="horizontal" itemSize="5" class="example-viewport">
          <div class="d-flex  flex-row">
            <div *cdkVirtualFor="let d of (mDocuments);trackBy:trackByMethod;let i = index" class="example-item ">
              <a (click)="openLink(d.url)">
                <img [src]="d.url" style="width: 250px; height: 250px" class="img-thumbnail img-fluid" alt="">
              </a>
              <p style="flex-grow: 9; font-size: 14px" class="text-center">{{d.description}}</p>
              <button mat-icon-button color="warn" (click)="deleteAdmissionFile(i,d,'documents')">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
      <!--COPY-->
    </div>
    <!--        <div class="col-md-6">-->


  </div>
  </div>





<!--<prettyjson [obj]="data"></prettyjson>-->
